/**
 * Peak DNA Product Form
 * Handles tub selection, subscribe/one-time toggle, price calculation, and AJAX add-to-cart
 */
(function() {
  'use strict';

  class PeakProductForm {
    constructor(el) {
      this.el = el;
      this.tubCount = 1;
      this.purchaseType = 'subscribe';
      this.basePrice = parseFloat(el.dataset.basePrice || '45');
      this.currency = el.dataset.currency || '£';

      // Parse available selling plans from Liquid data attribute
      this.sellingPlans = [];
      try {
        this.sellingPlans = JSON.parse(el.dataset.sellingPlans || '[]');
      } catch (err) {
        console.warn('Peak: failed to parse selling plans', err);
      }

      // Cache DOM elements
      this.tubButtons = el.querySelectorAll('[data-tub]');
      this.purchaseOptions = el.querySelectorAll('[data-purchase-type]');
      this.subscribePriceEl = el.querySelector('[data-subscribe-price]');
      this.subscribeCompareEl = el.querySelector('[data-subscribe-compare]');
      this.onetimePriceEl = el.querySelector('[data-onetime-price]');
      this.perDayEl = el.querySelector('[data-per-day]');
      this.annualSavingsEl = el.querySelector('[data-annual-savings]');
      this.addToCartBtn = el.querySelector('[data-add-to-cart]');
      this.deliveryNote = el.querySelector('[data-delivery-note]');
      this.freeShippingBadge = el.querySelector('[data-free-shipping]');
      this.stickyPriceEl = document.querySelector('#peak-sticky-cart [data-sticky-price]');

      this.bindEvents();
      this.updateUI();
    }

    bindEvents() {
      this.tubButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.tubCount = parseInt(btn.dataset.tub);
          this.updateUI();
        });
      });

      this.purchaseOptions.forEach(opt => {
        opt.addEventListener('click', () => {
          this.purchaseType = opt.dataset.purchaseType;
          this.updateUI();
        });
      });

      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
    }

    getSellingPlanForTubs(tubs) {
      // Map tub count to delivery frequency: 1 tub = 30 days, 2 tubs = 60 days, 3 tubs = 90 days
      if (!this.sellingPlans.length) return null;
      var targetDays = tubs * 30;

      // Try exact match by name (e.g. "30 Day subscription")
      var exact = this.sellingPlans.find(function(p) {
        return p.name && p.name.indexOf(targetDays + ' Day') === 0;
      });
      if (exact) return exact.id;

      // Fallback: index-based (0 = first plan = 30 day, 1 = 60 day, etc.)
      var idx = Math.min(tubs - 1, this.sellingPlans.length - 1);
      return this.sellingPlans[idx] ? this.sellingPlans[idx].id : this.sellingPlans[0].id;
    }

    getOnetimePrice() {
      return this.basePrice * this.tubCount;
    }

    getSubscribePrice() {
      return this.basePrice * this.tubCount * 0.85;
    }

    formatPrice(amount) {
      return this.currency + amount.toFixed(2);
    }

    updateUI() {
      var onetimePrice = this.getOnetimePrice();
      var subscribePrice = this.getSubscribePrice();
      var activePrice = this.purchaseType === 'subscribe' ? subscribePrice : onetimePrice;

      // Update tub buttons
      this.tubButtons.forEach(btn => {
        var count = parseInt(btn.dataset.tub);
        if (count === this.tubCount) {
          btn.classList.add('border-peak-green', 'bg-peak-cream');
          btn.classList.remove('border-gray-200');
        } else {
          btn.classList.remove('border-peak-green', 'bg-peak-cream');
          btn.classList.add('border-gray-200');
        }
      });

      // Update purchase type cards + native radio inputs
      this.purchaseOptions.forEach(opt => {
        var type = opt.dataset.purchaseType;
        var radio = opt.querySelector('input[type="radio"]');
        var isActive = type === this.purchaseType;

        if (isActive) {
          opt.classList.add('bg-peak-cream', 'border-peak-green');
          opt.classList.remove('border-transparent');
        } else {
          opt.classList.remove('bg-peak-cream', 'border-peak-green');
          opt.classList.add('border-transparent');
        }

        if (radio) radio.checked = isActive;
      });

      // Update subscribe price + strikethrough
      if (this.subscribePriceEl) {
        this.subscribePriceEl.textContent = this.formatPrice(subscribePrice);
      }
      if (this.subscribeCompareEl) {
        this.subscribeCompareEl.textContent = this.formatPrice(onetimePrice);
      }

      // Update one-time price
      if (this.onetimePriceEl) {
        this.onetimePriceEl.textContent = this.formatPrice(onetimePrice);
      }

      // Update per-day cost
      if (this.perDayEl) {
        var days = this.tubCount * 30;
        var perDay = subscribePrice / days;
        this.perDayEl.textContent = 'JUST ' + this.formatPrice(perDay) + '/DAY';
      }

      // Update annual savings
      if (this.annualSavingsEl) {
        var monthlySaving = onetimePrice - subscribePrice;
        var annualSaving = (monthlySaving / this.tubCount) * 12;
        var freeTubs = Math.floor(annualSaving / this.basePrice);
        var tubWord = freeTubs === 1 ? 'tub' : 'tubs';
        this.annualSavingsEl.innerHTML = 'You save <span class="text-peak-light-green">' + this.formatPrice(annualSaving) + ' per year</span> \u2014 that\u2019s ' + (freeTubs >= 2 ? 'almost ' : '') + freeTubs + ' free ' + tubWord + '!';
      }

      // Update delivery note
      if (this.deliveryNote) {
        this.deliveryNote.textContent = 'Delivery every ' + (this.tubCount * 30) + ' days. Cancel anytime.';
      }

      // Show/hide free shipping badge
      if (this.freeShippingBadge) {
        this.freeShippingBadge.style.display = this.purchaseType === 'subscribe' ? '' : 'none';
      }

      // Update CTA text
      if (this.addToCartBtn) {
        var btnText = this.addToCartBtn.querySelector('[data-btn-text]');
        if (btnText) {
          btnText.textContent = this.purchaseType === 'subscribe' ? 'Subscribe & Save' : 'Add to Cart';
        }
      }

      // Update sticky bar price
      if (this.stickyPriceEl) {
        this.stickyPriceEl.textContent = this.formatPrice(activePrice);
      }
    }

    addToCart() {
      var variantId = this.el.dataset.variantId;
      if (!variantId) return;

      var btn = this.addToCartBtn;
      btn.disabled = true;
      btn.classList.add('opacity-70');

      // Find cart drawer / cart notification to request fresh section HTML
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var cartIconBubble = document.getElementById('cart-icon-bubble');

      var sectionsToRender = [];
      if (cartDrawer) sectionsToRender.push('cart-drawer');
      if (cartNotification) sectionsToRender.push('cart-notification');
      if (cartIconBubble) sectionsToRender.push('cart-icon-bubble');

      // Pick the correct selling plan based on tub count (30/60/90 day)
      var sellingPlanId = null;
      if (this.purchaseType === 'subscribe') {
        sellingPlanId = this.getSellingPlanForTubs(this.tubCount);
        if (!sellingPlanId) {
          console.warn('Peak: subscribe selected but no selling plan found. Falling back to one-time.');
        }
      }

      var body = {
        items: [{
          id: parseInt(variantId),
          quantity: this.tubCount,
          selling_plan: sellingPlanId
        }]
      };

      if (sectionsToRender.length > 0) {
        body.sections = sectionsToRender.join(',');
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(body)
      })
      .then(function(r) { return r.json(); })
      .then(function(parsedState) {
        btn.disabled = false;
        btn.classList.remove('opacity-70');

        // Handle API errors
        if (parsedState.status) {
          console.warn('Cart add error:', parsedState.description || parsedState.message);
          return;
        }

        // Update cart sections using the returned HTML
        if (parsedState.sections) {
          // Update cart icon bubble (cart count)
          if (parsedState.sections['cart-icon-bubble']) {
            var bubbleHtml = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
            var bubbleSource = bubbleHtml.querySelector('.shopify-section');
            var bubbleTarget = document.getElementById('cart-icon-bubble');
            if (bubbleSource && bubbleTarget) {
              bubbleTarget.innerHTML = bubbleSource.innerHTML;
            }
          }

          // Update cart drawer contents
          if (parsedState.sections['cart-drawer'] && cartDrawer) {
            var drawerHtml = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
            var drawerInner = drawerHtml.querySelector('cart-drawer');
            if (drawerInner) {
              cartDrawer.innerHTML = drawerInner.innerHTML;
              cartDrawer.classList.remove('is-empty');
            }
          }

          // Update cart notification contents
          if (parsedState.sections['cart-notification'] && cartNotification) {
            var notifHtml = new DOMParser().parseFromString(parsedState.sections['cart-notification'], 'text/html');
            var notifInner = notifHtml.querySelector('cart-notification');
            if (notifInner) {
              cartNotification.innerHTML = notifInner.innerHTML;
            }
          }
        }

        // Publish Shopify pub/sub event for any other listeners (Dawn pattern)
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'peak-product-form',
            productVariantId: variantId,
            cartData: parsedState
          });
        }

        // Open cart drawer or notification
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(btn);
        } else if (cartNotification && typeof cartNotification.open === 'function') {
          cartNotification.open();
        } else {
          var cartIcon = document.querySelector('.header__icon--cart');
          if (cartIcon) cartIcon.click();
        }
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        btn.disabled = false;
        btn.classList.remove('opacity-70');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-peak-product-form]').forEach(function(el) {
      new PeakProductForm(el);
    });
  });
})();
